export const LOAD_USER = 'LOAD_USER';
export const USER_LOGOUT = 'USER_LOGOUT';
export const LOAD_PARAMS = 'LOAD_PARAMS';
export const LOAD_MOSTRAR_ALERTA_ATUALIZAR_PAGINA = 'LOAD_MOSTRAR_ALERTA_ATUALIZAR_PAGINA';
export const LOAD_CAMPANHA = 'LOAD_CAMPANHA';
export const CLEAR_CAMPANHA = 'CLEAR_CAMPANHA';
export const LOAD_API_INFORMATION = 'LOAD_API_INFORMATION';